const mapProduct = (product) => {
  const {
    description, small_image 
  } = product

  const newDescription =
        typeof description === "object" ? description.html : description
  const newSmallImage =
        typeof small_image === "object" ? small_image.url : small_image

  return {
    ...product,
    description: newDescription,
    small_image: newSmallImage,
  }
}

export default mapProduct
